import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Header from "../../PublicOrdering/pages/Header";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";
import playBeep from "./PlayBeep";

const OrderSummary = () => {
  const location = useLocation();
  const { orgData, orderResponse, orderPost, phoneNumber } = location.state || {};
  const navigate = useNavigate();
  const { orgcode } = useParams();

  const cart = useSelector((state) => state.publicOrderingCart);
  const [savedOrder, setSavedOrder] = useState(null);
  const customerInfo = JSON.parse(localStorage.getItem("CustomerInfo"));

  const orderDetails = orderResponse?.items || orderPost?.orderDetails || [];
  const orderData = {
    orderId: orderResponse?.orderId || orderPost?.orderRefrenceId || "N/A",
    placedTime: orderResponse?.orderDate || orderPost?.orderDate || "N/A",
    customer: customerInfo?.customer?.name || {
      name: phoneNumber ? `Phone Customer (${phoneNumber})` : "Guest",
      phoneNumber: phoneNumber || "N/A",
    },
    items: orderDetails.map((item) => ({
      uid: item.id,
      name: item.name || item.productName,
      qty: item.qty || item.quantity,
      productPrice: item.productPrice,
      totalPrice: item.price || item?.productPrice,
      addons: item.addons || item.children,
      attributes: item.attributes,
      note: item.note,
      total: item.total,
    })),
    total: orderResponse?.totalAmount || orderPost?.grandTotal || 0,
    orgCode: orgcode,
  };

  if (!orderData) {
    return (
      <Container className="py-3 py-md-4">
        <Card>
          <CardBody className="text-center py-4">
            <h5 className="mb-3" style={{ fontSize: "1rem" }}>
              No order found
            </h5>
            <p style={{ fontSize: "0.875rem", color: "#6c757d" }}>
              Your cart is empty and no recent order exists.
            </p>
            <Button
              color="primary"
              size="sm"
              onClick={() => {
                playBeep();
                navigate(`/${orgcode}`);
              }}
            >
              Go Back
            </Button>
          </CardBody>
        </Card>
      </Container>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f8f9fa",
        paddingBottom: "120px",
      }}
    >
      {/* Fixed Header */}

      {/* Main Content */}
      <Container className="py-4" style={{ maxWidth: 1200 }}>
        <Header orgData={orgData} />
        <Row className="g-3">
          <Col xs={12} lg={{ size: 10, offset: 1 }} xl={{ size: 8, offset: 2 }}>
            {/* Page Title */}
            <div className="mb-3">
              <h3
                className="fw-bold mb-0"
                style={{
                  fontSize: "1.125rem",
                  color: "#212529",
                }}
              >
                Order Summary
              </h3>
            </div>

            {/* Order Info Card */}
            <Card
              className="mb-3"
              style={{
                border: "none",
                boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                borderRadius: "10px",
              }}
            >
              <CardBody style={{ padding: "14px" }}>
                {/* Customer Info */}
                <Row className="g-2">
                  <Col md={4}>
                    {/* Order ID */}
                    <div
                      className="mb-3 pb-2"
                      style={{
                        borderBottom: "1px solid #e9ecef",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "0.7rem",
                          color: "#6c757d",
                          marginBottom: "3px",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          fontWeight: "600",
                        }}
                      >
                        Order ID
                      </div>
                      <div
                        style={{
                          fontSize: "0.875rem",
                          fontWeight: "700",
                          color: "#212529",
                        }}
                      >
                        {orderData.orderId}
                      </div>
                    </div>
                  </Col>
                  <Col xs={4}>
                    <div
                      style={{
                        fontSize: "0.7rem",
                        color: "#6c757d",
                        marginBottom: "3px",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        fontWeight: "600",
                      }}
                    >
                      Customer
                    </div>
                    <div
                      style={{
                        fontSize: "0.8rem",
                        fontWeight: "600",
                        color: "#212529",
                      }}
                    >
                      {customerInfo?.user?.username || "Guest"}
                    </div>
                  </Col>
                  <Col xs={4}>
                    <div
                      style={{
                        fontSize: "0.7rem",
                        color: "#6c757d",
                        marginBottom: "3px",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        fontWeight: "600",
                      }}
                    >
                      Phone
                    </div>
                    <div
                      style={{
                        fontSize: "0.8rem",
                        fontWeight: "600",
                        color: "#212529",
                      }}
                    >
                      {customerInfo?.user?.phoneNumber || "N/A"}
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {/* Items Card */}
            <Card
              style={{
                border: "none",
                boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                borderRadius: "10px",
              }}
            >
              <CardBody style={{ padding: "14px" }}>
                {/* Section Header */}
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "6px" }}
                  >
                    <span style={{ fontSize: "1rem" }}>🛒</span>
                    <h5
                      className="mb-0 fw-bold"
                      style={{ fontSize: "0.95rem" }}
                    >
                      Ordered Items
                    </h5>
                  </div>
                  <span
                    style={{
                      fontSize: "0.7rem",
                      color: "#6c757d",
                      fontWeight: "600",
                    }}
                  >
                    {orderData.items.length}{" "}
                    {orderData.items.length === 1 ? "item" : "items"}
                  </span>
                </div>

                {/* Items List */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {orderData.items.map((it, idx) => (
                    <div
                      key={it.uid || it.id || idx}
                      style={{
                        padding: "10px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px",
                        border: "1px solid #e9ecef",
                      }}
                    >
                      {/* Item Header */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: "10px",
                          marginBottom: "6px",
                        }}
                      >
                        {/* Left: Name & Price */}
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div
                            style={{
                              fontWeight: "600",
                              fontSize: "0.8rem",
                              marginBottom: "3px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              color: "#212529",
                            }}
                          >
                            {it.name}
                          </div>
                          <div style={{ fontSize: "0.7rem", color: "#6c757d" }}>
                            Rs. <NumberWithCommas number={it.productPrice} />{" "}
                            each
                          </div>
                        </div>

                        {/* Right: Qty & Total */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                            gap: "3px",
                            flexShrink: 0,
                          }}
                        >
                          <div
                            style={{
                              fontSize: "0.7rem",
                              color: "#495057",
                              backgroundColor: "white",
                              padding: "2px 6px",
                              borderRadius: "4px",
                              border: "1px solid #dee2e6",
                              fontWeight: "600",
                            }}
                          >
                            Qty: {it.qty}
                          </div>
                          <div
                            style={{
                              fontWeight: "700",
                              fontSize: "0.8rem",
                              color: "#f85606",
                            }}
                          >
                            Rs.{" "}
                            <NumberWithCommas
                              number={
                                it.total || (it.totalPrice || 0) * (it.qty || 0)
                              }
                            />
                          </div>
                        </div>
                      </div>

                      {/* Item Details */}
                      {((it.addons || []).length > 0 ||
                        it.note ||
                        (it.attributes && it.attributes.length > 0)) && (
                        <div
                          style={{
                            padding: "8px",
                            backgroundColor: "white",
                            border: "1px solid #e9ecef",
                            borderRadius: "6px",
                            marginTop: "6px",
                          }}
                        >
                          {/* Addons */}
                          {(it.addons || []).length > 0 && (
                            <div className="mb-2">
                              <div
                                style={{
                                  fontSize: "0.7rem",
                                  fontWeight: "700",
                                  color: "#495057",
                                  marginBottom: "4px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Add-ons
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "3px",
                                }}
                              >
                                {(it.addons || []).map((a, i) => (
                                  <div
                                    key={i}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "0.75rem",
                                      color: "#6c757d",
                                      paddingLeft: "6px",
                                    }}
                                  >
                                    <span>• {a.name || a.productName}</span>
                                    {a.price && (
                                      <span
                                        style={{
                                          fontWeight: "600",
                                          color: "#495057",
                                        }}
                                      >
                                        Rs. {a.price}
                                      </span>
                                    )}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                          {/* Attributes */}
                          {it.attributes && it.attributes.length > 0 && (
                            <div className="mb-2">
                              <div
                                style={{
                                  fontSize: "0.7rem",
                                  fontWeight: "700",
                                  color: "#495057",
                                  marginBottom: "4px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Options
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "4px",
                                }}
                              >
                                {it.attributes.map((a, i) => (
                                  <span
                                    key={i}
                                    style={{
                                      fontSize: "0.7rem",
                                      backgroundColor: "#e9ecef",
                                      padding: "3px 6px",
                                      borderRadius: "4px",
                                      color: "#495057",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {a.title}: {a.value}
                                  </span>
                                ))}
                              </div>
                            </div>
                          )}

                          {/* Notes */}
                          {it.note && (
                            <div>
                              <div
                                style={{
                                  fontSize: "0.7rem",
                                  fontWeight: "700",
                                  color: "#495057",
                                  marginBottom: "4px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Special Instructions
                              </div>
                              <div
                                style={{
                                  fontSize: "0.75rem",
                                  color: "#6c757d",
                                  fontStyle: "italic",
                                  paddingLeft: "6px",
                                }}
                              >
                                "{it.note}"
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Fixed Bottom Bar */}
      <div
        className="fixed-bottom bg-white shadow-lg "
        style={{
          borderTop: "2px solid #e9ecef",
          zIndex: 99,
        }}
      >
        <Container>
          <div style={{ padding: "10px 0" } } className="col-lg-8 col-12 mx-auto">
            <Row className="g-2">
              <Col xs={12}>
                <div
                  className="d-flex justify-content-between align-items-center mb-2"
                  style={{ padding: "0 2px" }}
                >
                  <span
                    style={{
                      fontSize: "0.8rem",
                      fontWeight: "700",
                      color: "#495057",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Total Amount
                  </span>
                  <span
                    style={{
                      fontSize: "1.05rem",
                      fontWeight: "700",
                      color: "#f85606",
                    }}
                  >
                    Rs. <NumberWithCommas number={orderData.total} />
                  </span>
                </div>
              </Col>

              {/* <Col xs={6}>
                <Button
                  color="primary"
                  style={{
                    width: "100%",
                    padding: "10px",
                    fontWeight: "600",
                    fontSize: "0.8rem",
                    borderRadius: "8px",
                    border: "1px solid #dee2e6",
                    color: "#fff",
                  }}
                  onClick={() => {
                    playBeep();
                    navigate(`/${orderData.orgCode}`);
                  }}
                >
                  ← Menu
                </Button>
              </Col> */}

              <Col xs={12}>
                <Button
                  style={{
                    width: "100%",
                    padding: "10px",
                    fontWeight: "600",
                    fontSize: "0.8rem",
                    borderRadius: "8px",
                    backgroundColor: "#f85606",
                    border: "none",
                    boxShadow: "0 2px 6px rgba(248, 86, 6, 0.25)",
                  }}
                  onClick={() => {
                    playBeep();
                    navigate(`/${orgcode}/customer-checkout`, {
                      state: { orgData, orderResponse },
                    });
                  }}
                >
                  Proceed to Checkout →
                </Button>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default OrderSummary;
